export default __webpack_public_path__ + "static/media/sort-descending.09803309.svg";